import { LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js'
import Decimal from 'decimal.js'
import { u128ToDecimal } from '../utils/HedgeConstants'
import { LiquidationPoolEra } from './LiquidationPoolEra'
import { LiquidationPoolState } from './LiquidationPoolState'
import { StakingPool } from './StakingPool'

export class StakingPoolPosition {
  public publicKey: PublicKey
  public owner: PublicKey
  public pool: StakingPool
  public poolPublicKey: PublicKey
  public deposited: number

  public startHedgeRewardAccumulator: Decimal
  public startUshFeeAccumulator: Decimal
  public startCollateralFeeAccumulator: Decimal[]
  public closedCollateralFeeAccumulator: Decimal[]
  public timestampOpened: number
  public timestampClosed: number
  public closedRewardedTokens: Decimal
  public state: string

  constructor(poolPositionInfo: any, key: PublicKey, pool: StakingPool) {
    this.publicKey = key

    this.owner = poolPositionInfo.owner
    this.pool = pool
    this.poolPublicKey = poolPositionInfo.pool
    this.deposited = poolPositionInfo.deposited.toNumber()
    this.startHedgeRewardAccumulator = u128ToDecimal(poolPositionInfo.startHedgeRewardAccumulator)
    this.startUshFeeAccumulator = u128ToDecimal(poolPositionInfo.startUshFeeAccumulator)

    this.startCollateralFeeAccumulator = poolPositionInfo.startCollateralFeeAccumulator.map(
      (accum: any) => {
        return u128ToDecimal(accum)
      }
    )
    this.closedCollateralFeeAccumulator = poolPositionInfo.closedCollateralFeeAccumulator.map(
      (accum: any) => {
        return u128ToDecimal(accum)
      }
    )
    this.timestampOpened = poolPositionInfo.timestampOpened.toNumber()
    this.timestampClosed = poolPositionInfo.timestampClosed.toNumber()

    this.closedRewardedTokens = u128ToDecimal(poolPositionInfo.closedRewardedTokens)

    this.state = Object.keys(poolPositionInfo.state)[0]
  }

  public isOpen(): boolean {
    return this.state === 'open'
  }
  public getUshAvailable(): Decimal {
    return this.pool.ushFeeAccumulator
      .sub(this.startUshFeeAccumulator)
      .mul(new Decimal(this.deposited))
  }

  public getRewardsAtIndex(index: number): Decimal {
    return this.pool.collateralFeeAccumulator[index]
      .sub(this.startCollateralFeeAccumulator[index])
      .mul(new Decimal(this.deposited))
  }

  public hasUnclaimedRewards(): boolean {
    for (let i = 0; i < this.startCollateralFeeAccumulator.length; i++) {
      if (this.getRewardsAtIndex(i).gt(0)) {
        return true
      }
    }
    return false
  }
}
